import _ from 'lodash';
import { connect } from 'react-redux';

import ChatHistory from 'presentation/components/ChatHistory.jsx';
import { getMessages } from 'app/modules';
import { isDemoSelfServiceEnabled } from 'app/modules';

export const mapStateToProps = state => {
  return {
    messageHistory: getMessages(state),
    isChatEnded: !!_.get(state, 'session.isEnded'),
    isAgentTyping: !!_.get(state, 'session.isAgentTyping'),
    isDemoSelfServiceEnabled: isDemoSelfServiceEnabled(state),
  };
};

const ChatHistoryContainer = connect(mapStateToProps)(ChatHistory);

export default ChatHistoryContainer;
